// Wspólne tłumaczenia dla modułu Produkcji Kuchni.
// Używane w: ProductionReport (RU/TH/PL), ProductionOverview (PL),
// ProductionCatalog (PL — panel managera). Klucze pasują do wartości w DB (kolumna `unit`).

export const UNITS = ["worek", "skrzynka", "kg", "paczka", "porcja", "pojemnik", "butelka", "litr", "szt"];

export const UNIT_LABELS = {
  worek:    { pl: "worek",    ru: "мешок",     th: "กระสอบ" },
  skrzynka: { pl: "skrzynka", ru: "ящик",      th: "ลัง" },
  kg:       { pl: "kg",       ru: "кг",        th: "กก." },
  paczka:   { pl: "paczka",   ru: "пачка",     th: "แพ็ค" },
  porcja:   { pl: "porcja",   ru: "порция",    th: "จาน" },
  pojemnik: { pl: "pojemnik", ru: "контейнер", th: "กล่อง" },
  butelka:  { pl: "butelka",  ru: "бутылка",   th: "ขวด" },
  litr:     { pl: "litr",     ru: "литр",      th: "ลิตร" },
  szt:      { pl: "szt",      ru: "шт",        th: "ชิ้น" },
};

export function unitLabel(unit, lang = "pl") {
  if (!unit) return "";
  const row = UNIT_LABELS[unit];
  if (!row) return unit; // fallback dla wartości spoza listy
  return row[lang] || row.pl || unit;
}

// S1 — predefiniowane kompetencje (kto zwykle to robi — informacyjnie).
// Manager może wpisać własną, ale te są sugerowane w Select.
export const COMPETENCES = [
  { key: "sosy",      pl: "Sosy",             ru: "Соусы",       th: "ซอส" },
  { key: "sajgonki",  pl: "Sajgonki",         ru: "Спринг-роллы", th: "ปอเปี๊ยะ" },
  { key: "warzywa",   pl: "Warzywa (cięte)",  ru: "Овощи (нарез.)", th: "ผัก (ตัด)" },
  { key: "marynaty",  pl: "Marynaty",         ru: "Маринады",    th: "หมัก" },
  { key: "pasty",     pl: "Pasty",            ru: "Пасты",       th: "แป้ง/เพสต์" },
  { key: "bazy",      pl: "Bazy / buliony",   ru: "Базы/бульоны", th: "น้ำสต๊อก" },
  { key: "inne",      pl: "Inne",             ru: "Прочее",      th: "อื่นๆ" },
];
